import React from "react";
import { useParams } from "react-router-dom";

import LoginComponent from "@/components/screens/Login";
import { LOGIN_MESSAGES } from "@/messages/login/login.messages";
import { type Language } from "@/types/language.types";

const Login: React.FC = () => {
  useParams<{ lang?: Language }>();
  return <LoginComponent messages={LOGIN_MESSAGES} />;
};

export default Login;
